import { useTranslation } from 'next-i18next';
import { PlusSmallCircleIcon } from '@/icons';
import { Button } from '@/ui_v3';
export const AddAnswerButton = ({
  onClick,
  disabled
}: {
  onClick: () => void;
  disabled: boolean;
}) => {
  const {
    t
  } = useTranslation(['build']);
  return <Button variant={'contained'} intent="neutral" size="md" disabled={disabled} leftSlot={<PlusSmallCircleIcon size="xs" />} onMouseDown={e => {
    e.preventDefault();
    e.stopPropagation();
  }} onClick={e => {
    e.preventDefault();
    onClick();
  }} data-sentry-element="Button" data-sentry-component="AddAnswerButton" data-sentry-source-file="AddAnswerButton.tsx">
      {t('build:build.subjective.addSimilarAnswer')}
    </Button>;
};